module.exports = __webpack_public_path__ + "img/humedad.fa44815f.svg";